// import CheckBoxWrap  from "../CheckBoxWrap";
// import VueQuillEditor from "vue-quill-editor";
// import TodoList from "../../TodoList";
// import GetOptionsHoc from "./GetOptionsHoc";
// import FileUpComp from "../../FileUpComp";
// import TreeExtend from "../../TreeExtend";
// import CheckBoxWrap from "../../CheckBoxWrap";
// import DateTimeRanges from "../../DateTimeRanges"; seniorMenu
import SelectExtend from "../../SelectExtend";
import NumberRange from "../../NumberRange";
import { defineAsyncComponent, defineComponent, h } from "vue";
import { ElRadioGroup, ElRadio, ElRadioButton, ElCascader, ElAutocomplete, ElInput, ElInputNumber, ElTimePicker, ElDatePicker, ElDialog, ElSwitch } from "element-plus";
import quantityRange from "../../quantityRange";
import radioGroup from "../../radioGroup";
import rangeTime from "../../rangeTime";
import BatchInput from "../../BatchInput";
// import VueQuillEditor from "../../index";
import type { MemberComponentType } from "./types";
// const SetRadioGroup = RadioGroup;

// const SetRadio = Radio;

// const RadioExtend = GetOptionsHoc(SetRadioGroup, SetRadio, {
//   setAttrFunc: (res) => {
//     return Object.assign(res, {
//       name: res.label,
//       label: res.value,
//       value: res.value,
//     });
//   },
// });

// const RadioButtonExtend = GetOptionsHoc(SetRadioGroup, RadioButton, {
//   setAttrFunc: (res) => {
//     return Object.assign(res, {
//       name: res.label,
//       label: res.value,
//       value: res.value,
//     });
//   },
// });
// const CheckBoxWrapExtend = GetOptionsHoc(CheckBoxWrap);
// const TodoListExtend = GetOptionsHoc(TodoList);
// const CascaderExtend = GetOptionsHoc(Cascader);

// Dialog.props.modal = {
//   type: Boolean,
//   default: false,
// };
// Dialog.props.closeOnClickModal = {
//   type: Boolean,
//   default: false,
// };
// DatePicker.props.unlinkPanels = {
//   type: Boolean,
//   default: true,
// };

// SelectExtend.props.clearable = {
//   type: Boolean,
//   default: true,
// };
// SelectExtend.props.filterable = {
//   type: Boolean,
//   default: true,
// };

export const memberComponents: MemberComponentType[] = [
  {
    type: ["editor"],
    Component: typeof window === "undefined"
      ? defineComponent({
          name: "QuickFormEditorFallback",
          render() {
            return h(ElInput);
          },
        })
      : defineAsyncComponent(() => import("../../Editor")),
  },
  {
    type: ["batchInput"],
    Component: BatchInput,
  },
  {
    type: ["bankCard", "phone", "password", "money", "text"],
    Component: ElInput,
  },
  {
    type: ["autocomplete"],
    Component: ElAutocomplete,
  },
  {
    type: ["number"],
    Component: ElInputNumber,
  },
  {
    type: ["numberrange"],
    Component: NumberRange,
  },
  {
    type: ["timepicker"],
    Component: ElTimePicker,
  },
  {
    type: ["datepicker"],
    Component: ElDatePicker,
  },
  {
    type: ["rangeTime"],
    Component: rangeTime,
  },
  {
    type: ["select"],
    Component: SelectExtend,
  },
  {
    type: ["switch"],
    Component: SelectExtend,
  },
  {
    type: ["switch"],
    Component: ElSwitch,
  },
  {
    type: ["quantityRange"],
    Component: quantityRange,
  },
  {
    type: ["radioGroup"],
    Component: radioGroup,
  },
  {
    type: ["cascader"],
    Component: ElCascader,
  },
  // {
  //   type: ["cascader"],
  //   Component: CascaderExtend,
  // },
  // {
  //   type: ["tobolist"],
  //   Component: TodoListExtend,
  // },
  // {
  //   type: ["treeextend"],
  //   Component: TreeExtend,
  // },
  // {
  //   type: ["file"],
  //   Component: FileUpComp,
  // },
  // {
  //   type: ["radio"],
  //   Component: RadioExtend,
  // },
  // {
  //   type: ["radiobutton"],
  //   Component: RadioButtonExtend,
  // },
  // {
  //   type: ["checkbox"],
  //   Component: CheckBoxWrapExtend,
  // },
  // {
  //   type: ["datetimeranges"],
  //   Component: DateTimeRanges,
  // },
];

// text文本类型 textarea长文本类型 number数字类型 select下拉类型 file文件类型  imgFile图片文件类型 date时间类型 editor富文本类型 checkbox多选类型 radio单选类型 selecttree 树形选择类型 switch开关 quantityRange数量选择
